import {Component} from '../component.interface';
import {NavSliderDomInjector} from './nav-slider-dom-injector';
import {NavSliderConfig} from './nav-slider-config.interface';

export class NavSlider implements Component {
    bootstrapped = false;
    navSliderDomInjector: NavSliderDomInjector;

    constructor(
        private window: Window,
        private document: Document,
        public config: NavSliderConfig
    ) {
    }

    init(): void {
    }

    injectDom(hostElement?: HTMLElement): void {
        this.navSliderDomInjector = new NavSliderDomInjector(this.document, this.window, hostElement, this);
    }

    refresh(): void {
        this.navSliderDomInjector.toggleClippingClass();
    }

    slideLeft(): void {
        this.navSliderDomInjector.slideLeft();
    }

    slideRight(): void {
        this.navSliderDomInjector.slideRight();
    }
}